import { render, staticRenderFns } from "./localeSelector.vue?vue&type=template&id=3db63ea4"
import script from "./localeSelector.vue?vue&type=script&lang=js"
export * from "./localeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports